import React from 'react';

import { ContentBlock } from 'components/modules/AutoruLayout/ContentBlock/ContentBlock';
import { DatePicker } from 'components/modules/Insurance/components/DatePicker/DatePicker';
import { FormWrapper } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';
import {
  MAX_DATE,
  MIN_DATE,
  OUTPUT_CUSTOMER_DATE_FORMAT,
} from 'components/modules/Insurance/Insurance.constants';
import { FIELDS } from 'store/insuranceAnketa/constants';
import { InputMask } from 'utils/inputMask';

import { usePersonalDataPresenter } from './PersonalData.presenter';
import * as S from './PersonalData.styles';

export const PersonalData = ({ isOwnerForm }) => {
  const presenter = usePersonalDataPresenter({ isOwnerForm });

  return (
    <ContentBlock title="Данные клиента">
      <FormWrapper>
        <S.Genders
          disabled={presenter.disabled}
          name={FIELDS.GENDER}
          value={presenter.values[FIELDS.GENDER]}
          onChange={presenter.onChangeGender}
        />
        <S.FullNameInputs
          disabled={presenter.disabled}
          error={presenter.errors[FIELDS.FULL_NAME]}
          name={FIELDS.FULL_NAME}
          value={presenter.values[FIELDS.FULL_NAME]}
          onChange={presenter.onChange}
          onChangeGender={presenter.onChangeGender}
        />
        <DatePicker
          disabled={presenter.disabled}
          error={presenter.errors[FIELDS.BIRTHDATE]}
          label="Дата рождения"
          maxDate={MAX_DATE}
          minDate={MIN_DATE}
          name={FIELDS.BIRTHDATE}
          outputFormat={OUTPUT_CUSTOMER_DATE_FORMAT}
          value={presenter.values[FIELDS.BIRTHDATE]}
          onChange={presenter.onChange}
        />
        <S.TextInputMasked
          disabled={presenter.disabled}
          error={presenter.errors[FIELDS.MOBILE_PHONE]}
          label="Мобильный телефон"
          mask={InputMask.CELLPHONE_PRIVATE_NEW_LAZY}
          name={FIELDS.MOBILE_PHONE}
          unmask={false}
          value={presenter.values[FIELDS.MOBILE_PHONE]}
          onChange={presenter.onChange}
        />
        <S.TextInputMasked
          disabled={presenter.disabled}
          error={presenter.errors[FIELDS.EMAIL]}
          label="Почта"
          mask={InputMask.EMAIL_EN}
          name={FIELDS.EMAIL}
          value={presenter.values[FIELDS.EMAIL]}
          onChange={presenter.onChange}
        />
      </FormWrapper>
    </ContentBlock>
  );
};
